import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      
      <main className="flex-1 py-12 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-slate-900 mb-2">Kebijakan Privasi</h1>
          <p className="text-slate-500 mb-8">Terakhir diperbarui: 27 Juli 2026</p>
          
          <div className="prose prose-slate max-w-none">
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">1. Pendahuluan</h2>
              <p className="text-slate-600 mb-4">
                Bimbel My Tentor ("kami", "kita", atau "MyTentor") berkomitmen untuk melindungi privasi Anda. 
                Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, mengungkapkan, 
                dan melindungi informasi pribadi Anda ketika menggunakan platform try out online kami di mytentor.id.
              </p>
              <p className="text-slate-600">
                Dengan menggunakan layanan kami, Anda menyetujui pengumpulan dan penggunaan informasi 
                sesuai dengan kebijakan ini.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">2. Informasi yang Kami Kumpulkan</h2>
              <p className="text-slate-600 mb-4">Kami mengumpulkan beberapa jenis informasi:</p>
              
              <h3 className="text-lg font-medium text-slate-800 mb-2">a. Informasi Pribadi</h3>
              <ul className="list-disc list-inside text-slate-600 mb-4 space-y-1">
                <li>Nama lengkap</li>
                <li>Alamat email</li>
                <li>Nomor telepon/WhatsApp</li>
                <li>Asal sekolah/instansi</li>
                <li>Foto profil (opsional)</li>
              </ul>
              
              <h3 className="text-lg font-medium text-slate-800 mb-2">b. Informasi Akademik</h3>
              <ul className="list-disc list-inside text-slate-600 mb-4 space-y-1">
                <li>Hasil try out dan skor</li>
                <li>Riwayat latihan soal</li>
                <li>Progress pembelajaran</li>
                <li>Waktu pengerjaan</li>
              </ul>
              
              <h3 className="text-lg font-medium text-slate-800 mb-2">c. Informasi Teknis</h3>
              <ul className="list-disc list-inside text-slate-600 space-y-1">
                <li>Alamat IP</li>
                <li>Jenis browser dan perangkat</li>
                <li>Waktu akses dan halaman yang dikunjungi</li>
              </ul>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">3. Penggunaan Informasi</h2>
              <p className="text-slate-600 mb-4">Informasi yang kami kumpulkan digunakan untuk:</p>
              <ul className="list-disc list-inside text-slate-600 space-y-1">
                <li>Menyediakan layanan try out online dan materi pembelajaran</li>
                <li>Mengelola akun pengguna dan autentikasi</li>
                <li>Menampilkan ranking dan leaderboard</li>
                <li>Mengirim notifikasi terkait layanan (jadwal try out, hasil, promo)</li>
                <li>Meningkatkan kualitas layanan dan pengalaman pengguna</li>
                <li>Memproses transaksi pembayaran</li>
                <li>Memberikan dukungan pelanggan</li>
              </ul>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">4. Berbagi Informasi</h2>
              <p className="text-slate-600 mb-4">
                Kami <strong>tidak menjual</strong> informasi pribadi Anda kepada pihak ketiga. 
                Informasi dapat dibagikan dalam kondisi berikut:
              </p>
              <ul className="list-disc list-inside text-slate-600 space-y-1">
                <li><strong>Ranking Publik:</strong> Nama dan skor dapat ditampilkan di leaderboard</li>
                <li><strong>Payment Gateway:</strong> Data transaksi untuk memproses pembayaran</li>
                <li><strong>Kewajiban Hukum:</strong> Jika diwajibkan oleh hukum atau proses hukum</li>
              </ul>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">5. Keamanan Data</h2>
              <p className="text-slate-600 mb-4">
                Kami menerapkan langkah-langkah keamanan yang wajar untuk melindungi data Anda:
              </p>
              <ul className="list-disc list-inside text-slate-600 space-y-1">
                <li>Enkripsi password dengan bcrypt</li>
                <li>Koneksi HTTPS yang aman</li>
                <li>Akses terbatas ke data pribadi hanya untuk staf yang berwenang</li>
                <li>Backup data secara berkala</li>
              </ul>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">6. Hak Pengguna</h2>
              <p className="text-slate-600 mb-4">Anda memiliki hak untuk:</p>
              <ul className="list-disc list-inside text-slate-600 space-y-1">
                <li>Mengakses dan melihat data pribadi Anda</li>
                <li>Memperbarui atau memperbaiki data yang tidak akurat</li>
                <li>Meminta penghapusan akun dan data (dengan menghubungi admin)</li>
                <li>Menarik persetujuan atas penggunaan data</li>
              </ul>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">7. Cookies</h2>
              <p className="text-slate-600">
                Website kami menggunakan cookies dan local storage untuk menyimpan preferensi pengguna, 
                sesi login, dan meningkatkan pengalaman browsing. Anda dapat mengatur browser untuk 
                menolak cookies, namun beberapa fitur mungkin tidak berfungsi dengan baik.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">8. Perubahan Kebijakan</h2>
              <p className="text-slate-600">
                Kami dapat memperbarui Kebijakan Privasi ini dari waktu ke waktu. Perubahan signifikan 
                akan diberitahukan melalui email atau notifikasi di website. Penggunaan layanan setelah 
                perubahan berarti Anda menyetujui kebijakan yang diperbarui.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">9. Kontak</h2>
              <p className="text-slate-600 mb-4">
                Jika Anda memiliki pertanyaan tentang Kebijakan Privasi ini, silakan hubungi kami:
              </p>
              <div className="bg-slate-50 rounded-lg p-4 text-slate-600">
                <p><strong>Bimbel My Tentor</strong></p>
                <p>Alamat: Jl. Gaperta No. 218 A Medan Helvetia</p>
                <p>Email: mytentor2017@gmail.com</p>
                <p>WhatsApp: +62 812 6201 7001</p>
              </div>
            </section>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
